import { FormItemProps, Switch } from 'antd';

import { Card, Column, Form, Row, Text, Title } from '@bancobarigui/barihaus';

type Props = FormItemProps & {
  text: string;
  title: string;
};

export function SwitchCardItem({ title, text, ...rest }: Props) {
  return (
    <Card>
      <Row gutter={[24, 16]}>
        <Column>
          <Form.Item initialValue={false} {...rest}>
            <Switch />
          </Form.Item>
        </Column>

        <Column className="flex flex-col gap-2">
          <Title level={5}>{title}</Title>

          <Text>{text}</Text>
        </Column>
      </Row>
    </Card>
  );
}
